import React from 'react';
import { Grid, Button } from '@mui/material';

import DeleteIcon from '@mui/icons-material/DeleteForever';
import SaveIcon from '@mui/icons-material/Save';

interface ProfileSectionControllerProp {
  xs?: number;
  md?: number;
  deletable?: boolean;
  saveButtonHandler: () => void;
  deleteButtonHandler?: () => void;
}

const ProfileSectionController: React.FC<ProfileSectionControllerProp> = ({
  saveButtonHandler,
  deleteButtonHandler,
  xs = 12,
  md = 12,
  deletable = true,
}) => {
  return (
    <Grid
      item
      xs={xs}
      md={md}
      container
      direction="row"
      justifyContent="flex-end"
      alignItems="center"
      sx={{ gap: 1, mt: 2 }}
    >
      {deletable ? (
        <Button
          variant="contained"
          color="error"
          onClick={deleteButtonHandler}
          startIcon={<DeleteIcon />}
          sx={{
            backgroundColor: 'var(--ttg-red, #d32f2f)',
            '&:hover': { backgroundColor: 'var(--button-hover-red, #b71c1c)' },
            textTransform: 'none',
            fontWeight: 600,
          }}
        >
          Delete
        </Button>
      ) : null}
      <Button
        variant="contained"
        color="primary"
        onClick={saveButtonHandler}
        startIcon={<SaveIcon />}
        sx={{
          backgroundColor: 'var(--ttg-green)',
          '&:hover': { backgroundColor: 'var(--button-hover-green)' },
          textTransform: 'none',
          fontWeight: 600,
        }}
      >
        Save
      </Button>
    </Grid>
  );
};
export default ProfileSectionController;
